import { render, staticRenderFns } from "./TabPurchaseInvoiceHeader.vue?vue&type=template&id=0152d1ad"
import script from "./TabPurchaseInvoiceHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPurchaseInvoiceHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports